$(document).ready(function () {
    $(".poem-body").readmore({
        moreLink: '<a href="#" class="dotted">Развернуть</a>',
        lessLink: '<a href="#" class="dotted">Свернуть</a>'
    });
});